<div class="filters" [class.shrink]="shrinkButtons" *ngIf="enableFilters">
    <section class="buttons" [attr.aria-label]="filters.labels.wrapper">
        <!--Top Filters Buttons-->
        <finder-filter-button
            class="filter-button"
            *ngFor="let filter of topFilters"
            [id]="filter.id"
            [ariaLabel]="filter.ariaLabel"
            [icon]="filter.icon"
            [selected]="filter.selected"
            (click)="toggleTopFilter(filter)">
            <span>{{filter.label}}</span>
        </finder-filter-button>
        <!--Height Filter Button-->
        <finder-filter-button
            #heightButton
            class="filter-button"
            *ngIf="heightButtonSg()"
            [ariaLabel]="heightFilterButton.ariaLabel"
            [icon]="heightFilterButton.icon"
            [selected]="heightFilterButton.selected"
            (click)="toggleHeightFilter()">
            <span>{{heightFilterButton.label}}</span>
            <!-- Store the button so we can access it later in the template -->
            @let tmp = setHeightBtn(heightButton);
        </finder-filter-button>
        <finder-filter-button
            class="filter-button"
            *ngFor="let drawer of drawerFilters"
            [id]="drawer.button.id"
            [ariaLabel]="drawer.button.ariaLabel"
            [icon]="drawer.button.icon"
            [selected]="drawer.button.selected"
            [class.slim]="drawer.slim"
            [shrink]="shrinkButtons"
            (click)="toggleDrawer(drawer, $event)">
            <span *ngIf="!drawer.button.displayedDrawer; else displayedAllFiltersDrawer">
                <span>{{drawer.button.label}}</span>
                <span *ngIf="drawer.showTotal">
                    &nbsp;({{appliedFacets.length}})
                </span>
            </span>
            <ng-template #displayedAllFiltersDrawer>
                {{drawer.button.label}}
            </ng-template>
        </finder-filter-button>
    </section>
    <section class="drawers">
        <!--Height Filter Slider Container-->
        <!-- Once the finder-filter-button has been created we store the element and access it here -->
        <!-- This is better then relying on a @ViewChild selector due to changeDetection issues -->
        <finder-list-drawer
            class="height-filter-drawer"
            *ngIf="heightButtonSg()"
            [(displayedState)]="heightFilterButton.displayedDrawer"
            [sourceElement]="getHeightBtn().nativeElement"
            closeOnClickOutside="true">
            <finder-height-slider
                [title]="filters.heightFilter.labels.sectionTitle"
                [subtitle]="filters.heightFilter.labels.sectionSubtitle"
                [heightLabel]="filters.labels.height">
            </finder-height-slider>
        </finder-list-drawer>
        <ng-template #drawersPlaceholder></ng-template>
    </section>
    <ng-content select="[remyCta]"></ng-content>
    <!--Filter Dinner List-->
    <finder-dine-availability-filter
        *ngIf="filters.diningFormFilter"
        [class.hidden]="shrinkButtons"
        [diningFilter]="filters.diningFormFilter">
    </finder-dine-availability-filter>
    <!--Filter Pills-->
    <finder-filter-pills
        class="filter-pills"
        *ngIf="!shrinkButtons"
        [pills]="appliedFacets"
        [clearLabel]="filters.labels.clearAll"
        [pillAriaLabel]="filters.labels.pillAriaLabel"
        [pillsWrapperLabel]="filters.labels.pillsWrapper"
        (clear)="clearPills()"
        (pillClose)="closePill($event)">
    </finder-filter-pills>
</div>
